confirm.defaults = {
    title: "FABER",
    titleClass: "",
    type: "default",
    typeAnimated: true,
    draggable: false,
    dragWindowGap: 15,
    dragWindowBorder: true,
    animateFromElement: false,
    smoothContent: true,
    content: "Sind Sie sicher, dass Sie fortfahren wollen?",
    buttons: {},
    defaultButtons: {
        ok: {
            text: "Bestätigen",
            btnClass: "btn-primary",
            keys: ["enter"],
            action: function () {
            }
        },
        close: {
            text: "Abbruch",
            btnClass: "btn-primary",
            keys: ["esc"],
            action: function () {}
        }
    },
    contentLoaded: function(data, status, xhr){
    },
    icon: "",
    lazyOpen: false,
    bgOpacity: null,
    theme: "bootstrap",
    animation: "top",
    closeAnimation: "bottom",
    animationSpeed: 150,
    animationBounce: 1,
    rtl: false,
    container: "body",
    containerFluid: false,
    backgroundDismiss: false,
    backgroundDismissAnimation: "shake",
    autoClose: false,
    closeIcon: true,
    closeIconClass: false,
    watchInterval: 100,
    columnClass: "col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3 col-xs-10 col-xs-offset-1",
    boxWidth: "50%",
    scrollToPreviousElement: true,
    scrollToPreviousElementAnimate: true,
    useBootstrap: true,
    offsetTop: 40,
    offsetBottom: 40,
    bootstrapClasses: {
        container: "container",
        containerFluid: "container-fluid",
        row: "row",
    },
    onContentReady: function () {},
    onOpenBefore: function () {},
    onOpen: function () {},
    onClose: function () {},
    onDestroy: function () {},
    onAction: function () {}
};